import { baseActionEpic, IRequestAction, IRequestDataAction, progressEpic } from "../base-epic";
import { UTILITIES } from "constants/action-types";
import siteConfig from "site-config";
import { IBrand, IBrandDetailed, IDataFlow, IFlowV2 } from "containers/management/management-types";
import { IFlowState } from "reducers/dataflow-reducers";
import { add as snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";

export const fetchBrandsEpic = progressEpic<IRequestAction, IBrand[]>(
    UTILITIES.DATAFLOW_MANAGEMENT.BRANDS.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    })
);

export const fetchDataflowEpic = progressEpic<IRequestAction, IFlowState>(
    UTILITIES.DATAFLOW_MANAGEMENT.FLOW.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    })
);

export const fetchBrandDetailedEpic = progressEpic<IRequestAction, IBrandDetailed>(
    UTILITIES.DATAFLOW_MANAGEMENT.BRAND_DETAILED.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    }),
    {
        dataCustomizer: (response) => {
            const preferencesMap = new Map<any, any>();
            (response.settings.preferences || []).forEach((p) => {
                preferencesMap[p.preference] = p.value;
            });
            return {
                _id: response._id,
                name: response.name,
                active: response.active,
                preferences: preferencesMap,
            };
        },
    }
);

export const saveFlowEpic = baseActionEpic<IRequestDataAction<IDataFlow>>(
    UTILITIES.DATAFLOW_MANAGEMENT.FLOW.SAVE,
    ({ payload }) => ({
        method: "PUT",
        url: siteConfig.api + payload.url,
        body: payload.body,
    })
);

export const resetFlowEpic = baseActionEpic<IRequestAction>(
    UTILITIES.DATAFLOW_MANAGEMENT.FLOW.RESET,
    ({ payload }) => ({ method: "POST", url: siteConfig.api + payload.url }),
    () => [snackbarAdd({ message: format("Changes saved. All products will be reprocessed for this merchant.") })]
);

export const updateCompanyFlowV2Epic = baseActionEpic<IRequestDataAction<Partial<IFlowV2>>>(
    UTILITIES.DATAFLOW_MANAGEMENT.FLOW_V2.UPDATE,
    ({ payload }) => ({ method: "PUT", url: siteConfig.api + payload.url, body: payload.body }),
    () => [snackbarAdd({ message: format("Company Flow V2 has been updated") })]
);

export const fetchBrandDataflowEpic = progressEpic<IRequestAction, IFlowState>(
    UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.FETCH,
    ({ payload }) => ({
        method: "GET",
        url: siteConfig.api + payload.url,
    })
);

export const saveBrandDataFlowEpic = baseActionEpic<IRequestDataAction<IDataFlow>>(
    UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.SAVE,
    ({ payload, meta }) => ({
        method: "PUT",
        url: siteConfig.api + payload.url,
        body: payload.body,
        meta,
    }),
    (responsePayload) => {
        responsePayload?.request?.meta?.cb?.();
        return [];
    }
);

export const resetBrandDataFlowEpic = baseActionEpic<IRequestAction>(
    UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.RESET,
    ({ payload, meta }) => ({ method: "POST", url: siteConfig.api + payload.url, meta }),
    (responsePayload) => {
        responsePayload?.request?.meta?.cb?.();
        return [];
    }
);
